import type { ElementType, ReactNode } from "react"
import { Check } from "@/shared/components/ui/icons"

export interface IProps {
  iconElem?: ElementType
  icon?: ReactNode
  children?: ReactNode
}

export function SystemFeatureText({ iconElem: IconElem = Check, icon, children }: IProps) {
  return (
    <div className="mb-7 flex items-center gap-4">
      {icon ? icon : IconElem ? <IconElem className="min-w-5" color="#94A3B8" size={30} /> : ""}
      <p>{children}</p>
    </div>
  )
}
